import * as React from "react";
import { decode } from "blurhash";

const BLUR_HASH_SIZE = 32;

interface IProps extends React.CanvasHTMLAttributes<HTMLCanvasElement> {
  hash?: string;
  width?: number;
  height?: number;
  punch?: number;
}

export default function BlurHashCanvas({
  hash,
  width = 128,
  height = 128,
  punch,
  ...rest
}: IProps) {
  const canvasRef = React.useRef<HTMLCanvasElement>(null);
  let resizeWidth = BLUR_HASH_SIZE;
  let resizeHeight = BLUR_HASH_SIZE;
  if (width > height) {
    resizeWidth = Math.floor(BLUR_HASH_SIZE * (width / height));
  } else if (height > width) {
    resizeHeight = Math.floor(BLUR_HASH_SIZE * (height / width));
  }
  React.useEffect(() => {
    if (hash && canvasRef.current) {
      const image = decode(hash, resizeWidth, resizeHeight, punch);
      const ctx = canvasRef.current.getContext(
        "2d",
      ) as CanvasRenderingContext2D;
      const imageData = ctx.createImageData(resizeWidth, resizeHeight);
      imageData.data.set(image);
      ctx.putImageData(imageData, 0, 0);
    }
  }, []);
  return (
    <canvas
      {...rest}
      height={resizeHeight}
      width={resizeWidth}
      ref={canvasRef}
    />
  );
}
